import { IS_E2E } from '@omnipresentgroup/constants';
import { globalStyles } from '@omnipresentgroup/design-system';
import { createGlobalStyle } from 'styled-components';
import reset from 'styled-reset';

import '@omnipresentgroup/design-system/styles.css';

if (!IS_E2E) {
  await import('@omnipresentgroup/design-tokens/dist/css/fonts.css');
}

/**
 * Note: these containers (#react-refresh-overlay, #webpack-dev-server-client-overlay) have been hidden
 * because they are the error overlay iframes that webpack introduces to show the uncaugth errors
 * They are disabled through css because there are issues to disable them through the used dev server (@nx/react:module-federation-dev-server)
 */
const GlobalStyle = createGlobalStyle`
  ${reset}

  html, body {
    font-family: var(--omni-ds-fonts-default);
    background-color: var(--omni-ds-colors-background-page);
  }
  #root {
    height: 100%;
  }
  #react-refresh-overlay, #webpack-dev-server-client-overlay {
    display: none
  }
`;

export const GlobalStyles = ({ children }: { children: React.ReactNode }) => {
  globalStyles();

  return (
    <>
      <GlobalStyle />
      {children}
    </>
  );
};
